<template>
  <div class="container-fluid p0">
    <div class="row">
      <div class="col-md-12 col-xs-12 col-sm-12 col-12">
        <div class="big-loader">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  methods: {
    logout(message) {
      this.$toast.error(message);
      setTimeout(() => {
        this.$store.dispatch('appLogout');
        this.$store.dispatch('deleteSessionCookie');
        window.location.href = '/awto';
      }, 3000);
    },
  },
  mounted() {
    console.log('mmmmmmm');
    let redirect = this.$route.query.redirect;
    if (!redirect) {
      console.log('huh?');
      this.logout(this.$t('toast.redirectionTimeout'));
      redirect = '/awto/account';
    }
    axios
      .get(redirect)
      .then(response => {
        if (response.request.responseURL.search('/awto/sign-up/') === -1) {
          window.location.href = redirect;
        } else {
          this.logout(this.$t('toast.revokedSession'));
        }
      })
      .catch(e => {
        console.log(e);
        this.logout(this.$t('toast.revokedSession'));
      });
    setTimeout(() => {
      this.logout(this.$t('toast.redirectionTimeout'));
    }, 15000);
  },
};
</script>
